/**
 * Security utility for validating and sanitizing redirect paths
 * Prevents open redirect vulnerabilities
 */

// Whitelist of allowed redirect paths
const ALLOWED_REDIRECTS = [
  '/pricing',
  '/subscriptions',
  '/dashboard',
  '/guest-checkout',
  '/payment-success',
  '/why-bin-washing',
  '/about-us',
  '/contact',
];

/**
 * Sanitizes and validates a redirect path to prevent open redirect attacks
 * @param path - The path to sanitize (from localStorage/sessionStorage)
 * @returns A safe redirect path (defaults to /pricing if invalid)
 */
export function sanitizeRedirectPath(path: string | null): string {
  // Default to pricing if no path provided
  if (!path) return '/pricing';
  
  // Remove any leading origin/domain to prevent external redirects
  const cleanPath = path.replace(/^https?:\/\/[^\/]+/, '');
  
  // Must start with / and not contain .. (path traversal)
  if (!cleanPath.startsWith('/') || cleanPath.includes('..')) {
    return '/pricing';
  }
  
  // Extract base path (before query params)
  const basePath = cleanPath.split('?')[0];
  
  // Check if base path or any parent path is in whitelist
  const isAllowed = ALLOWED_REDIRECTS.some(allowed => 
    basePath === allowed || basePath.startsWith(allowed + '/')
  );
  
  return isAllowed ? cleanPath : '/pricing';
}
